import apiClient from "../../client/apiClient"

const BASE = "/grade-blurbs"

export type GradeBlurb = {
  _id: string
  gradeLetter: string
  blurb: string
  displayOrder: number
}

export const gradeBlurbsApi = {
  list: async (): Promise<{ success: boolean; data: GradeBlurb[] }> => {
    const res = await apiClient({ method: "GET", url: BASE })
    return res.data
  },
  bulkSave: async (items: { gradeLetter: string; blurb: string }[]) => {
    const res = await apiClient({ method: "PUT", url: `${BASE}/bulk`, data: { items } })
    return res.data
  },
  remove: async (gradeLetter: string) => {
    const res = await apiClient({ method: "DELETE", url: `${BASE}/${encodeURIComponent(gradeLetter)}` })
    return res.data
  },
}
